import { PROGRAM_CONTENT_ENTRIES_RECEIVE } from './actions';

const defaultState = {
  entries: [],
  meta: {},
};

export default function programContentLibraryReducer(state = defaultState, action) {
  switch (action.type) {
  case PROGRAM_CONTENT_ENTRIES_RECEIVE:
    return {
      ...state,
      entries: action.payload.entries,
      meta: action.payload.meta,
    };
  default:
    return state;
  }
}
